import React from "react";
import { styled } from "../../stitches.config";
import Link from "../../components/Link";
import { bodyLarge } from "../commonStyles/Fonts";
import Media from "../../components/common/Media";

interface PhotoOnTopCarouselProps {
    article?: any;
    dataAnalyticsName?: string;
}
const PhotoOnTopCarousel: React.FC<PhotoOnTopCarouselProps> = ({
    article,
    dataAnalyticsName
}) => {
    const isDesktop = window.innerWidth > 996;

    return (
        <Wrapper>
            <Link to={article.url} data-analytics-name={dataAnalyticsName}>
                <ImageWrapper>
                    <Media
                        src={article?.picture?.img}
                        preserveRatio={false}
                        aspectRatio={1.5}
                        height={isDesktop ? 72 : 150}
                        width={isDesktop ? 108 : 224}
                    />
                </ImageWrapper>
                <Title className={bodyLarge()}>{article.title}</Title>
            </Link>
        </Wrapper>
    );
};

const Wrapper = styled("div", {
    width: "224px",
    position: "relative",

    "@bp4": {
        width: "calc(50% - 16px)"
    },

    "a": {
        color: "$grayscale100",
        position: "relative",
        "&:hover": {
            textDecoration: "underline",
            textDecorationColor: "$grayscale100",
        },

        "@bp4": {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
        },
    }
});


const ImageWrapper = styled("span", {
    marginBottom: "12px",
    position: "relative",
    display: "block",
    "& img": {
        width: "100%",
        height: "100%",
    },

    "@bp4": {
        maxWidth: "108px",
    },
});

const Title = styled("span", {
    maxHeight: "72px",
    overflow: "hidden",
    width: "100%",
    display: "block",

    "@bp4": {
        marginLeft: "16px",
    },
});


export default PhotoOnTopCarousel;
